import React from 'react'
import imageOne from '../../resource/aboutus/mvideo/1.png'
import bottomImage from '../../resource/aboutus/mvideo/2.png'
import TitleChnage from '../../Hook/TitleChnage'

const Mvideo = () => {

    TitleChnage("Monastory Video")

  return (
    <div className="mvideo-page inside-pages">
         <div className="right-box">
                <img src={imageOne} alt="Right Top Image" className="right-image" width={300} />
            </div>

        <h1 className='font-main text-center'>Monastory Video</h1> 

        <div className="box">
                <ul className="text-left h4-bold mt-5 lsit-style-none font-second text-bold">
                    <li>To offer a beautiful flower,</li>
                    <li>To light a fragrant candle,</li>
                    <li>To dwell in inner peace,</li>
                    <li>To reside at Buddha's presence.</li>

                    <li className='mt-6'>We have a place,</li>
                    <li>We have our Sangha.</li>
                    <li>Do you wish to see?</li>
                    <li>Come, let’s take a look.</li>
                </ul>
                </div>


       <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh', // Adjust height to your preference
      }} className='mt-5'>
      
    </div>


       <div className="bottom-box mt-5">
                <img src={bottomImage} alt="bottom-image" width={400} />
            </div>
    </div>
  )
}

export default Mvideo